<template>
  <collapsible-section class='_pt0 _pb0' :collapsed='internalCollapsed'>
    <template #headerText>
      <p class='color-leaf'>Reporting Codes</p>
    </template>
    <template #collapsibleSection>
      <async-loader v-if='memberDetailsLoading'/>
      <div v-else container>
        <div grid>
          <div column>
            <app-input
              v-if="codeIsFreeform(subGroupPlanInfo.benefitOptionSetting)"
              :disabled='memberLocked'
              v-model='$v.internalValue.benefitOption.$model'
              :required='codeIsRequired(subGroupPlanInfo.benefitOptionSetting)'
              :errorMessage="benefitOptionError"
              :invalid="$v.internalValue.benefitOption.$invalid"
              valueKey='benefitOption'
              label='Benefit Option:'
              @input="emitInternalValue"
              />
            <app-select
              v-else
              :disabled='memberLocked'
              v-model='$v.internalValue.benefitOption.$model'
              :required='codeIsRequired(subGroupPlanInfo.benefitOptionSetting)'
              :errorMessage="benefitOptionError"
              :invalid="$v.internalValue.benefitOption.$invalid"
              valueKey='benefitOption'
              label='Benefit Option:'
              :options="toSelectOptions(subGroupPlanInfo.benefitOptions)"
              @input="emitInternalValue"
              />
          </div>
          <div column>
            <app-input
              v-if="codeIsFreeform(subGroupPlanInfo.divisionCodeSetting)"
              :disabled='memberLocked'
              v-model='$v.internalValue.divisionCode.$model'
              :required='codeIsRequired(subGroupPlanInfo.divisionCodeSetting)'
              :errorMessage="divisionCodeError"
              :invalid="$v.internalValue.divisionCode.$invalid"
              valueKey='divisionCode'
              label='Division Code:'
              @input="emitInternalValue"
              />
            <app-select
              v-else
              :disabled='memberLocked'
              v-model='$v.internalValue.divisionCode.$model'
              :required='codeIsRequired(subGroupPlanInfo.divisionCodeSetting)'
              :errorMessage="divisionCodeError"
              :invalid="$v.internalValue.divisionCode.$invalid"
              valueKey='divisionCode'
              label='Division Code:'
              :options="toSelectOptions(subGroupPlanInfo.divisionCodes)"
              @input="emitInternalValue"
              />
          </div>
          <div column>
            <app-input
              v-if="codeIsFreeform(subGroupPlanInfo.locationCodeSetting)"
              :disabled='memberLocked'
              v-model='$v.internalValue.locationCode.$model'
              :required='codeIsRequired(subGroupPlanInfo.locationCodeSetting)'
              :errorMessage="locationCodeError"
              :invalid="$v.internalValue.locationCode.$invalid"
              valueKey='locationCode'
              label='Location Code:'
              @input="emitInternalValue"
              />
            <app-select
              v-else
              :disabled='memberLocked'
              v-model='$v.internalValue.locationCode.$model'
              :required='codeIsRequired(subGroupPlanInfo.locationCodeSetting)'
              :errorMessage="locationCodeError"
              :invalid="$v.internalValue.locationCode.$invalid"
              valueKey='locationCode'
              label='Location Code:'
              :options="toSelectOptions(subGroupPlanInfo.locationCodes)"
              @input="emitInternalValue"
              />
          </div>
        </div>
        <div grid>
          <div column>
            <app-input
              v-if="codeIsFreeform(subGroupPlanInfo.companyCodeSetting)"
              :disabled='memberLocked'
              v-model='$v.internalValue.companyCode.$model'
              :required='codeIsRequired(subGroupPlanInfo.companyCodeSetting)'
              :errorMessage="companyCodeError"
              :invalid="$v.internalValue.companyCode.$invalid"
              valueKey='companyCode'
              label='Company Code:'
              @input="emitInternalValue"
              />
            <app-select
              v-else
              :disabled='memberLocked'
              v-model='$v.internalValue.companyCode.$model'
              :required='codeIsRequired(subGroupPlanInfo.companyCodeSetting)'
              :errorMessage="companyCodeError"
              :invalid="$v.internalValue.companyCode.$invalid"
              valueKey='companyCode'
              label='Company Code:'
              :options="toSelectOptions(subGroupPlanInfo.companyCodes)"
              @input="emitInternalValue"
              />
          </div>
          <div column>
            <app-input
              :disabled='memberLocked'
              v-model='$v.internalValue.clientGroupNumber.$model'
              :errorMessage="clientGroupNumberError"
              :invalid="$v.internalValue.clientGroupNumber.$invalid"
              valueKey='clientGroupNumber'
              label='Client Group #:'
              @input="emitInternalValue"
              />
          </div>
          <div column>
            <app-input
              :disabled='memberLocked'
              v-model='$v.internalValue.reportingCode1.$model'
              :errorMessage="reportingCode1Error"
              :invalid="$v.internalValue.reportingCode1.$invalid"
              valueKey='reportingCode1'
              label='Reporting Code 1:'
              @input="emitInternalValue"
              />
          </div>
        </div>
        <div grid class='_mtxs'>
          <div column>
            <app-input
              :disabled='memberLocked'
              v-model='$v.internalValue.reportingCode2.$model'
              :errorMessage="reportingCode2Error"
              :invalid="$v.internalValue.reportingCode2.$invalid"
              valueKey='reportingCode2'
              label='Reporting Code 2:'
              @input="emitInternalValue"
              />
          </div>
          <div column>
            <app-input
              :disabled='memberLocked'
              v-model='$v.internalValue.reportingCode3.$model'
              :errorMessage="reportingCode3Error"
              :invalid="$v.internalValue.reportingCode3.$invalid"
              valueKey='reportingCode3'
              label='Reporting Code 3:'
              @input="emitInternalValue"
              />
          </div>
          <div column>
            <app-input
              :disabled='memberLocked'
              v-model='$v.internalValue.reportingCode4.$model'
              :errorMessage="reportingCode4Error"
              :invalid="$v.internalValue.reportingCode4.$invalid"
              valueKey='reportingCode4'
              label='Reporting Code 4:'
              @input="emitInternalValue"
              />
          </div>
        </div>
        <div grid>
          <div column>
            <app-input
              :disabled='memberLocked'
              v-model='$v.internalValue.reportingCode5.$model'
              :errorMessage="reportingCode5Error"
              :invalid="$v.internalValue.reportingCode5.$invalid"
              valueKey='reportingCode5'
              label='Reporting Code 5:'
              @input="emitInternalValue"
              />
          </div>
          <div column />
          <div column />
        </div>
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import AppInput from '@atoms/Input'
  import AppSelect from '@atoms/Select'
  import AsyncLoader from '@molecules/AsyncLoader'
  import CollapsibleSection from '@sections/CollapsibleSection'

  import autoExpandable from '@mixins/autoExpandable'
  import formattable from '@mixins/formattable'
  import validationMessagesInternalValue from '@mixins/validationMessagesInternalValue'
  import formReady from '@mixins/formReady'
  import ReportingCodes from '@mixins/ReportingCodes'

  import { updateValues } from '@utils'

  import { requiredIf, maxLength } from 'vuelidate/lib/validators'

  export default {
    mixins: [
      formattable,
      autoExpandable,
      validationMessagesInternalValue,
      formReady,
      ReportingCodes
    ],
    components: {
      CollapsibleSection,
      AppInput,
      AppSelect,
      AsyncLoader
    },
    props: {
      collapsed: {
        type: Boolean,
        default: true
      },
      memberDetailsLoading: {
        type: Boolean,
        default: false
      },
      memberLocked: Boolean,
      subGroupPlanInfo: {
        type: Object,
        default() {
          return {
            locationCodeSetting: null,
            companyCodeSetting: null,
            divisionCodeSetting: null,
            benefitOptionSetting: null,
            locationCodes: [],
            companyCodes: [],
            divisionCodes: [],
            benefitOptions: []
          }
        }
      },
      value: {
        type: Object,
        default: function() {
          return {
            divisionCode: '',
            benefitOption: '',
            locationCode: '',
            companyCode: '',
            clientGroupNumber: '',
            reportingCode1: '',
            reportingCode2: '',
            reportingCode3: '',
            reportingCode4: '',
            reportingCode5: ''
          }
        }
      }
    },
    data() {
      return {
        internalValue: {
          divisionCode: this.value.divisionCode,
          benefitOption: this.value.benefitOption,
          locationCode: this.value.locationCode,
          companyCode: this.value.companyCode,
          clientGroupNumber: this.value.clientGroupNumber,
          reportingCode1: this.value.reportingCode1,
          reportingCode2: this.value.reportingCode2,
          reportingCode3: this.value.reportingCode3,
          reportingCode4: this.value.reportingCode4,
          reportingCode5: this.value.reportingCode5
        }
      }
    },
    validations: {
      internalValue: {
        locationCode: {
          required: requiredIf(function() { return this.codeIsRequired(this.subGroupPlanInfo.locationCodeSetting) }),
          maxLength: maxLength(20)
        },
        companyCode: {
          required: requiredIf(function() { return this.codeIsRequired(this.subGroupPlanInfo.companyCodeSetting) }),
          maxLength: maxLength(20)
        },
        divisionCode: {
          required: requiredIf(function() { return this.codeIsRequired(this.subGroupPlanInfo.divisionCodeSetting) }),
          maxLength: maxLength(20)
        },
        clientGroupNumber: {
          maxLength: maxLength(20)
        },
        benefitOption: {
          required: requiredIf(function() { return this.codeIsRequired(this.subGroupPlanInfo.benefitOptionSetting) }),
          maxLength: maxLength(4)
        },
        reportingCode1: {
          maxLength: maxLength(20)
        },
        reportingCode2: {
          maxLength: maxLength(20)
        },
        reportingCode3: {
          maxLength: maxLength(20)
        },
        reportingCode4: {
          maxLength: maxLength(20)
        },
        reportingCode5: {
          maxLength: maxLength(20)
        }
      }
    },
    computed: {
      clientGroupNumberError() {
        if (!this.$v.internalValue.clientGroupNumber.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      reportingCode1Error() {
        if (!this.$v.internalValue.reportingCode1.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      reportingCode2Error() {
        if (!this.$v.internalValue.reportingCode2.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      reportingCode3Error() {
        if (!this.$v.internalValue.reportingCode3.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      reportingCode4Error() {
        if (!this.$v.internalValue.reportingCode4.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      reportingCode5Error() {
        if (!this.$v.internalValue.reportingCode5.maxLength) {
          return 'character limit exceeded'
        }
        return null
      }
    },
    created() {
      this.expandIfHasData(this.subGroupPlanInfo)
    },
    watch: {
      subGroupPlanInfo(newValue) {
        this.expandIfHasData(newValue)
      },
      value(newValue) {
        updateValues(this.internalValue, newValue)
      }
    },
    methods: {
      emitInternalValue() {
        this.$emit('input', this.internalValue)
      }
    }
  }
</script>
